<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="errorDialog" v-model="errorDialog" :max-width="size === 'sm' ? 295 : 364" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header success pa-0 text-center">
						<div class="text-right pa-1">
							<v-btn class="close-icon" small icon @click="close">
								<v-icon size="18">{{ icons.mdiClose }}</v-icon>
							</v-btn>
						</div>
						<h4 class="fs--24 fw--600 popup-header-text">Extension Offline</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content">
							<v-img src="@/assets/images/error.png" width="100%" contain height="100%"></v-img>
							<p class="fw--600 fs--13 white--text">
								We're currently offline for maintenance! We'll be back soon!
							</p>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from '@/store';
import { mdiClose } from '@mdi/js';

export default {
	props: {
		errorDialog: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['onClose'],
	setup(_, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const close = () => {
			ctx.emit('onClose');
		};

		const cancelEvent = event => {
			event.stopImmediatePropagation();
		};

		return {
			theme,
			size,
			close,
			cancelEvent,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>
